module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "list-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    ref: "list",
    staticClass: "list"
  }, [_c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "disable",
      "infinite-scroll-distance": "30"
    }
  }, _vm._l((_vm.students), function(student) {
    return _c('li', {
      directives: [{
        name: "tap",
        rawName: "v-tap",
        value: ({
          methods: _vm.goToStudentInfo,
          student: student
        }),
        expression: "{methods:goToStudentInfo,student:student}"
      }],
      key: student.id
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(student.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "class"
    }, [_vm._v(_vm._s(student.gradeName))]), _vm._v(" "), _c('i', {
      staticClass: "arrow"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "centerDiv"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.stateText)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('v-go-back-btn')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dbe957e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/StudentList.vue
// module id = 762
// module chunks = 1